import _default from './Grid';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/semantic-ui-react/dist/es/collections/Grid/index.js
// module id = 852
// module chunks = 0